<template>
  <div>
    <SearchInput />
  </div>
</template>

<script>
import SearchInput from '@/components/search/SearchInput.vue'
export default {
  components: {
    SearchInput,
  },
  data() {
    return {}
  },
  methods: {},
}
</script>

<style lang="scss" scoped>
container {
  position: relative;
  height: 100%;
  width: 100%;
}
</style>
